import React, { useState } from 'react';
import { EngagementForm } from '../components/Engagement/EngagementForm';
import { IntentConfirmation } from '../components/Engagement/IntentConfirmation';
import { CommunityAccess } from '../components/Engagement/CommunityAccess';
export const HowToEngage = () => {
  const [currentStep, setCurrentStep] = useState<'form' | 'intent' | 'community'>('form');
  const [formData, setFormData] = useState({});
  const handleFormSubmit = data => {
    setFormData(data);
    setCurrentStep('intent');
  };
  const handleIntentConfirm = (understood: boolean) => {
    if (understood) {
      setCurrentStep('community');
    } else {
      // If they need more details, we could handle that differently
      // For now, just proceed to community access
      setCurrentStep('community');
    }
  };
  return <div className="pt-20 bg-white min-h-screen" data-id="element-2804">
      <section className="relative py-16 border-b border-gray-200" data-id="element-2805">
        <div className="absolute inset-0 z-0" data-id="element-2806">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/veE5AXEU4CEztbBqZpUQcx/coverrs.png" alt="The Networking Salon" className="w-full h-full object-cover grayscale" data-id="element-2807" />
          <div className="absolute inset-0 bg-black bg-opacity-50" data-id="element-2808"></div>
        </div>
        <div className="container mx-auto px-4 relative z-10" data-id="element-2809">
          <div className="max-w-3xl mx-auto text-center" data-id="element-2810">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6" data-id="element-2811">
              Join The Salon
            </h1>
            <p className="text-xl text-gray-200 mb-8" data-id="element-2812">
              Join our community and connect with like-minded professionals
            </p>
          </div>
        </div>
      </section>
      <section className="py-16" data-id="element-2813">
        <div className="container mx-auto px-4" data-id="element-2814">
          <div className="max-w-3xl mx-auto" data-id="element-2815">
            {currentStep === 'form' && <EngagementForm onFormSubmit={handleFormSubmit} data-id="element-2816" />}
            {currentStep === 'intent' && <IntentConfirmation onConfirm={handleIntentConfirm} data-id="element-2817" />}
            {currentStep === 'community' && <CommunityAccess userLocation={formData.location || ''} data-id="element-2818" />}
          </div>
        </div>
      </section>
    </div>;
};